import {EElementType} from "../../../models/utils/EElementType";
import {ISpecifications} from "../../../models/utils/ISpecifications";


class SpecificationsService {

    public SPECS_STREETLIGHT_SEN_2: ISpecifications[] = [
        {
            type: EElementType.EnergyBox,
            quantity: 1
        },
        {
            type: EElementType.SolarPanel,
            quantity: 1
        },
        {
            type: EElementType.Mast,
            quantity: 1
        }
    ];

    public SPECS_GW: ISpecifications[] = [
        {
            type: EElementType.EnergyBox,
            quantity: 1
        },
        {
            type: EElementType.SolarPanel,
            quantity: 1
        },
    ]

}

export default new SpecificationsService();
